import gql from 'graphql-tag';

const SKIP_MONTH = gql`
  mutation skipMonth {
    skipMonth
  }
`;

export {SKIP_MONTH};
